import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/status")({
  component: Status,
});

function Status() {
  return (
    <div>{`{
        VITE_API_URL: ${import.meta.env.VITE_API_URL ?? ""}
    }`}</div>
  );
}
